import * as Comlink from "comlink";

let workerInstance = null;
let workerApi = null;

/**
 * Get or create the MD5 worker instance
 * @returns {Promise<Object>} The worker API wrapped with Comlink
 */
async function getMD5Worker() {
	if (!workerInstance) {
		// Create new worker using Vite's worker import syntax
		const MD5Worker = new Worker(
			new URL("../workers/md5Worker.js", import.meta.url),
			{ type: "module" },
		);

		// Wrap the worker with Comlink
		workerApi = Comlink.wrap(MD5Worker);
		workerInstance = MD5Worker;
	}

	return workerApi;
}

/**
 * Compute MD5 checksum in web worker
 * @param {File} file - The file to compute MD5 for
 * @returns {Promise<string>} Base64-encoded MD5 checksum
 */
export async function computeMD5InWorker(file) {
	const worker = await getMD5Worker();
	const base64Hash = await worker.computeMD5Base64(Comlink.transfer(file, []));
	return base64Hash;
}

/**
 * Cleanup the worker when no longer needed
 */
export function terminateMD5Worker() {
	if (workerInstance) {
		workerInstance.terminate();
		workerInstance = null;
		workerApi = null;
	}
}
